import PublicBasedTTSeatPermissionsRepository from "@shared/modules/seating/repositories/PublicBasedTTSeatPermissionsRepository";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import {
  BestAvailableItemType,
  BestAvailableSeatingQueryParamsType,
} from "@shared/modules/seating/types/seating-types";
import { UseQueryOptions } from "react-query";

const usePublicBasedTTSeatPermissions = () => {
  const repository = new PublicBasedTTSeatPermissionsRepository();

  const modelService = useModelService(repository);

  /**
   * Hook to fetch best available seating data
   * @param queryParams - Query parameters for best available seating
   * @param isBoxOffice - Whether this is a box office request (affects purchase limits)
   * @param options - Additional react-query options (e.g., enabled)
   */
  const useGetBestAvailableSeating = (
    queryParams: BestAvailableSeatingQueryParamsType,
    isBoxOffice = false,
    options?: Omit<
      UseQueryOptions<BestAvailableItemType>,
      "queryKey" | "queryFn"
    >
  ) => {
    return modelService.useGenericQuery<BestAvailableItemType>(
      "bestAvailable",
      {
        /**
         * This is a POST request because the increasing complexity of the query params, so its preferable to send them as a data payload.
         * this effectively works as a GET request, but with a data payload.
         */
        config: {
          method: "POST",
          data: {
            ...queryParams,
            is_box_office: isBoxOffice, // this allows the backend to use the box office purchase limits instead of the public purchase limits.
          },
        },
        options,
      }
    );
  };

  return {
    ...modelService,
    useGetBestAvailableSeating,
  };
};

export default usePublicBasedTTSeatPermissions;
